import React from 'react';
import { FlameIcon } from 'lucide-react';
import { scarcity } from '../data/offer';
export function ScarcityBar() {
  const filled = Math.round((scarcity.total - scarcity.remaining) / scarcity.total * 100);
  return <div className="mt-6" data-id="element-49" data-mp="2l44t4d5nijd4">
      <div className="flex items-center justify-between gap-3 text-sm font-semibold" data-id="element-50" data-mp="2l2trojzohnp6">
        <span className="flex items-center gap-1.5 text-white" data-id="element-51" data-mp="2q26ckz6zokp4">
          <FlameIcon className="h-4 w-4 text-danger" aria-hidden="true" data-id="element-52" data-mp="2b6gwfhohj1sb" />
          Only <span className="text-amber" data-id="element-53" data-mp="2g5l94iambhne">{scarcity.remaining} spots left</span> at the promo price
        </span>
        <span className="shrink-0 text-mist" data-id="element-54" data-mp="226lg6yg2oglf">{filled}% claimed</span>
      </div>
      <div className="relative mt-2 h-4 overflow-hidden rounded-full bg-ink ring-1 ring-line" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-55" data-mp="27552izykvueb">
        <div className="relative h-full overflow-hidden rounded-full bg-danger" style={{
        width: `${filled}%`
      }} data-id="element-56" data-mp="5d0fa1s0xl9x">
          <span className="bar-shine absolute inset-y-0 left-0 w-1/3 bg-white/25" aria-hidden="true" data-id="element-57" data-mp="33kihzmqi60j6" />
        </div>
      </div>
    </div>;
}